
import React from "react";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Button } from "@/components/ui/button";
import { Search, Plus } from "lucide-react";

interface WorksheetSearchProps {
  searchQuery: string;
  setSearchQuery: (query: string) => void;
  subjectFilter: string;
  setSubjectFilter: (subject: string) => void;
  subjects: string[];
  onCreateClick: () => void;
}

export const WorksheetSearch: React.FC<WorksheetSearchProps> = ({
  searchQuery,
  setSearchQuery,
  subjectFilter,
  setSubjectFilter,
  subjects,
  onCreateClick
}) => {
  return (
    <div className="flex flex-col md:flex-row gap-4 items-end">
      <div className="relative flex-grow">
        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-muted-foreground" />
        <Input
          placeholder="ค้นหาจากชื่อ หัวข้อ วิชา ระดับชั้น"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          className="pl-10 pr-4"
        />
      </div>

      <div className="flex flex-col space-y-2 w-full md:w-auto">
        <label htmlFor="subject-filter" className="text-sm font-medium">วิชา</label>
        <Select value={subjectFilter} onValueChange={setSubjectFilter}>
          <SelectTrigger className="w-full md:w-[180px]">
            <SelectValue placeholder="ทุกวิชา" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">ทุกวิชา</SelectItem>
            {subjects.map(subject => (
              <SelectItem key={subject} value={subject}>{subject}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      <Button 
        variant="default" 
        className="flex items-center gap-2"
        onClick={onCreateClick}
      >
        <Plus className="h-4 w-4" />
        เพิ่มชีทใหม่
      </Button>
    </div>
  );
};
